import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    KpiResultPeriodFieldHistory,
    KpiResultPeriodFieldHistoryItem,
} from '@masar/common/models';
import { KpiResultPeriodService } from '@masar/pages/kpi/kpi-result-period.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-period-field-history-dialog',
    templateUrl: './period-field-history-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PeriodFieldHistoryDialogComponent implements OnInit, OnDestroy {
    @Input() public periodId: string;

    @Input() public source: 'kpi-result' | 'data-entry-response';

    public resultAnalysisHistory: KpiResultPeriodFieldHistoryItem[] = [];

    public improvementProcedureHistory: KpiResultPeriodFieldHistoryItem[] = [];

    public isLoading = true;

    private unsubscribeAll = new Subject<void>();

    public constructor(
        private readonly kpiResultPeriodService: KpiResultPeriodService
    ) {}

    public ngOnInit(): void {
        this.loadHistory();
    }

    public ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    public trackByIndex(index: number): number {
        return index;
    }

    private loadHistory(): void {
        this.isLoading = true;

        this.kpiResultPeriodService
            .getFieldHistory(this.periodId, this.source)
            .pipe(
                takeUntil(this.unsubscribeAll),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe(history => {
                this.applyHistory(history);
            });
    }

    private applyHistory(history: KpiResultPeriodFieldHistory | null): void {
        const allItems = [
            ...(history?.resultAnalysis ?? []),
            ...(history?.improvementProcedure ?? []),
        ];

        const hasFieldType = allItems.some(item => !!item.fieldType);

        if (hasFieldType) {
            this.resultAnalysisHistory = allItems.filter(
                item => item.fieldType === 'result_analysis'
            );
            this.improvementProcedureHistory = allItems.filter(
                item => item.fieldType === 'improvement_procedure'
            );
            return;
        }

        this.resultAnalysisHistory = history?.resultAnalysis ?? [];
        this.improvementProcedureHistory = history?.improvementProcedure ?? [];
    }
}
